export const PLATFORM_FEE_DECIMAL = 0.2; // In decimal for percent
export const CUSTOMER_FEE_CENTS = 0; // In cents
export const COACH_FEE_CENTS = 0; // In cents
export const CREDIT_CARD_FEE_RATE_DECIMAL = 0.05;
export const MONTH_FREQUENCY = 12;
export const CONVERSION_TO_CENTS = 100;

interface Params {
  priceUnitAmount: number;
  customerFeeCents?: number;
  coachFeeCents?: number;
  creditCardFeeRateDecimal?: number;
  platformFeeRateDecimal?: number;
}

// NOTE: Do we need to do anymore to ensure we are only working with integers?
// We should be fine if we round all multiplication if we can trust priceUnitAmount
export const getSubscriptionItemizedTotal = ({
  priceUnitAmount,
  customerFeeCents = CUSTOMER_FEE_CENTS,
  coachFeeCents = COACH_FEE_CENTS,
  creditCardFeeRateDecimal = CREDIT_CARD_FEE_RATE_DECIMAL,
  platformFeeRateDecimal = PLATFORM_FEE_DECIMAL,
}: Params) => {
  const orderSubtotalUnitAmount = priceUnitAmount * MONTH_FREQUENCY; // Sum of items
  // Fees
  const customerApplicationFeeUnitAmount = Math.ceil(customerFeeCents);
  const sellerApplicationFeeUnitAmount = Math.ceil(coachFeeCents); // Note: Paid by the coach (indirectly) after the transaction is complete
  const platformFeeForSubscription = Math.ceil(orderSubtotalUnitAmount * platformFeeRateDecimal);
  const creditCardFeeUnitAmount = Math.ceil(orderSubtotalUnitAmount * creditCardFeeRateDecimal);
  const orderSubtotalWithPlatformFeesUnitAmount = orderSubtotalUnitAmount;

  /**
   * @note (Fees Bounce keeps) - Application fee is the Stripe terminology for the platform service fee that Bounce receives
   */
  const applicationFeeTotal =
    customerApplicationFeeUnitAmount +
    sellerApplicationFeeUnitAmount +
    platformFeeForSubscription +
    creditCardFeeUnitAmount;

  /**
   * @note (What the customer pays) - Seller fee is not in the order total. This total is what is paid by the customer. The coach's fee is deducted after money has been received.
   */
  const orderTotalUnitAmount = Math.ceil(orderSubtotalUnitAmount + applicationFeeTotal);

  /**
   * @note The coach receives the payment price minus the additional service fee from customer and the fee paid to us by the coach.
   */
  const coachAmountReceived = orderTotalUnitAmount - applicationFeeTotal;

  return {
    customerApplicationFee: customerApplicationFeeUnitAmount,
    sellerApplicationFee: sellerApplicationFeeUnitAmount,
    creditCardFee: creditCardFeeUnitAmount,
    orderSubtotal: orderSubtotalUnitAmount,
    orderTotal: orderTotalUnitAmount,
    orderSubtotalWithPlatformFeesUnitAmount,
    coachAmountReceived,
    applicationFeeTotal,
    // input
    priceUnitAmount,
    customerFeeCents,
    coachFeeCents,
    creditCardFeeRateDecimal,
    platformFeeForSubscription,
    platformFeeRateDecimal,
  };
};
